// src/i18n.ts
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import resourcesToBackend from 'i18next-resources-to-backend';

i18n
  .use(resourcesToBackend((lng: string) => import(`./locales/${lng}.json`)))
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'es', 'fr'],
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
    saveMissing: true,
    returnObjects: true,
    missingKeyHandler: function (lng, ns, key, fallbackValue) {
      console.warn('Missing translation key:', { lng, ns, key, fallbackValue });
    },
  });

export default i18n;
